import { Injectable } from '@angular/core';
import { Timer } from 'src/app/model/Timer';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  private _timers: Timer[] = [];
  constructor() {
    this._timers = [
      new Timer(1, Timer.MAX_TIME, "assets/images/timer1.png", "BÁSICO", "Máximo tiempo disponible"),
      new Timer(2, 600000, "assets/images/timer2.png", "FÁCIL", "Un poco mejor que el básico"),
      new Timer(3, 540000, "assets/images/timer3.png", "MODERADO", "La cosa se pone mas compleja"),
      new Timer(4, Timer.MIN_TIME, "assets/images/timer4.png", "DIFICIL", "Corre forest, corre"),
    ]
  }

  public getAll() {
    return Promise.resolve(this._timers);
  }

  public getRandom() {
    return this._timers[Math.round(Math.random() * (this._timers.length - 1))];
  }

  public getImages(): string[] {
    return this._timers.map(l => l.image);

  }
}
